/* Refrigerator Water Filter theme JS — cart drawer (AJAX), PDP tabs, gallery, auto-refill consent */
(function () {
  'use strict';

  var moneyFormat = window.RWF_MONEY_FORMAT || '${{amount}}';
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function showToast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartOverlay');

  function toggleCart(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    overlay && overlay.classList.toggle('show', open);
    /* stop the page behind scrolling under the drawer on touch devices */
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) drawer.querySelector('.drawer-close').focus();
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        var items = document.getElementById('CartDrawerItems');
        var total = document.getElementById('CartDrawerTotal');
        if (total) total.textContent = formatMoney(cart.total_price);
        if (!items) return cart;
        if (cart.item_count === 0) {
          items.innerHTML = '<div class="empty-cart">Your cart is empty.<br>Find your filter to get started.</div>';
        } else {
          items.innerHTML = cart.items.map(function (it) {
            var img = it.image ? '<img src="' + it.image + '&width=104" alt="" loading="lazy">' : '<span style="width:52px;height:52px;border-radius:8px;background:var(--ice);flex-shrink:0"></span>';
            var plan = it.selling_plan_allocation ? '<span class="sub-note" style="font-size:.72rem;color:var(--aqua-dark);font-weight:600;display:block">' + it.selling_plan_allocation.selling_plan.name + '</span>' : '';
            return '<div class="d-item">' + img +
              '<div><h4>' + it.product_title + '</h4>' + plan +
              '<span class="d-price">' + it.quantity + ' × ' + formatMoney(it.final_price) + '</span></div>' +
              '<div class="qty">' +
              '<button data-cart-change data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
              '<button data-cart-change data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              '</div></div>';
          }).join('');
        }
        return cart;
      });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); toggleCart(true); refreshCart(); return; }  /* open immediately; if the cart fetch is slow or fails the drawer still opens */
    if (e.target.closest('[data-cart-close]') || e.target === overlay) { toggleCart(false); return; }
    var change = e.target.closest('[data-cart-change]');
    if (change) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: change.dataset.key, quantity: parseInt(change.dataset.qty, 10) })
      }).then(refreshCart);
    }
  });

  /* Shopify explains exactly why an add failed in the response body. Throwing that
     away and showing "please try again" leaves the shopper with nothing to act on
     and whoever is debugging the store with nothing to go on, so read it out. */
  function cartError(res) {
    return res.json().catch(function () { return {}; }).then(function (data) {
      var why = data && (data.description || data.message);
      if (window.console) console.error('[cart] add failed', res.status, data);
      showToast(why ? 'Could not add to cart \u2014 ' + why
                    : 'Could not add to cart \u2014 please try again');
    });
  }

  /* AJAX add-to-cart: any form with data-ajax-cart, or quick-add buttons with data-quick-add="VARIANT_ID" */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();

    /* Shopify rejects an empty selling_plan outright, which is what happens when
       the subscription plan is not applied to this variant. Never send one. */
    var plan = form.querySelector('[name="selling_plan"]');
    if (plan && !plan.value) plan.disabled = true;

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) return cartError(r);
        return r.json().then(function () {
          /* Buy now: skip the cart drawer, go straight to checkout */
          if (form.getAttribute('data-checkout-redirect') === 'true') {
            showToast('Taking you to checkout\u2026');
            window.location.href = '/checkout';
            return;
          }
          refreshCart().then(function () { toggleCart(true); });
          showToast('Added to cart');
        });
      })
      .catch(function (err) {
        if (window.console) console.error('[cart] add threw', err);
        showToast('Could not add to cart \u2014 please try again');
      });
  });

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return cartError(r);
        return r.json().then(function () {
          refreshCart().then(function () { toggleCart(true); });
          showToast('Added to cart');
        });
      })
      .catch(function (err) {
        if (window.console) console.error('[cart] quick-add threw', err);
        showToast('Could not add to cart \u2014 please try again');
      });
  });


  /* ---------- PDP: tabs ---------- */
  document.querySelectorAll('[data-tab-target]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-tab-target]').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById(btn.dataset.tabTarget);
      panel && panel.classList.add('active');
    });
  });

  /* ---------- PDP: gallery ----------
     One swipeable track at every width. Touch swipes it natively; pointer devices
     drag it. Thumbs and the arrow keys drive it too. */
  (function () {
    var thumbs = [].slice.call(document.querySelectorAll('[data-thumb]'));
    var track  = document.querySelector('[data-gallery-track]');
    var strip  = document.querySelector('[data-thumbs]');
    if (!thumbs.length && !track) return;

    /* one slide plus the flex gap — read the gap rather than assume it */
    function step() {
      var first = track && track.firstElementChild;
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap);
      return first.getBoundingClientRect().width + (isNaN(gap) ? 8 : gap);
    }

    function index() {
      var s = step();
      return s ? Math.round(track.scrollLeft / s) : 0;
    }

    function mark(i) {
      thumbs.forEach(function (x, n) { x.classList.toggle('active', n === i); });
      /* keep the active thumb in view when the strip scrolls */
      if (strip && thumbs[i]) {
        var t = thumbs[i], sl = strip.scrollLeft, w = strip.clientWidth;
        if (t.offsetLeft < sl || t.offsetLeft + t.offsetWidth > sl + w) {
          strip.scrollTo({ left: t.offsetLeft - w / 2 + t.offsetWidth / 2, behavior: 'smooth' });
        }
      }
    }

    function goTo(i, smooth) {
      if (!track) return;
      var s = step();
      if (!s) return;
      var max = track.children.length - 1;
      i = Math.max(0, Math.min(max, i));
      track.scrollTo({ left: i * s, behavior: smooth === false ? 'auto' : 'smooth' });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var main = document.getElementById('GalleryMainImg');
        if (main) main.src = t.dataset.thumb;
        goTo(i);
        mark(i);
      });
    });

    /* Exposed so the bundle rows can bring the matching pack photo forward when
       the shopper picks a different pack size. One entry point on purpose — the
       caller shouldn't have to know that the track, the thumb strip and the
       no-JS <img> all need moving together. Out-of-range indexes are ignored so
       a mapping that outlives a deleted photo fails quietly instead of jumping
       the gallery to the wrong shot. */
    window.rwfGallery = {
      slides: track ? track.children.length : 0,
      show: function (i, smooth) {
        if (!track || !(i >= 0) || i > track.children.length - 1) return false;
        var slide = track.children[i].querySelector('img');
        var main  = document.getElementById('GalleryMainImg');
        if (main && slide) main.src = slide.src;
        goTo(i, smooth);
        mark(i);
        return true;
      }
    };

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          mark(index());
          ticking = false;
        });
      });

      /* keyboard, once the track has focus */
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        goTo(index() + (e.key === 'ArrowRight' ? 1 : -1));
      });

      /* drag-to-scroll for mice — touch is left alone so the native swipe,
         which has momentum the browser does far better, keeps working */
      if (track.children.length > 1) {
        var dragging = false, startX = 0, startLeft = 0, startIdx = 0, moved = 0, lastX = 0;

        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch' || e.button !== 0) return;
          dragging = true; moved = 0;
          startX = lastX = e.clientX;
          startLeft = track.scrollLeft;
          startIdx = index();
          track.classList.add('dragging');
          try { track.setPointerCapture(e.pointerId); } catch (err) {}
        });

        track.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          lastX = e.clientX;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > moved) moved = Math.abs(dx);
          track.scrollLeft = startLeft - dx;
        });

        ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
          track.addEventListener(evt, function (e) {
            if (!dragging) return;
            dragging = false;
            track.classList.remove('dragging');
            try { track.releasePointerCapture(e.pointerId); } catch (err) {}

            /* Snapping was off during the drag, so settle deliberately. Requiring
               half a slide of travel feels stodgy — a short flick past a tenth of
               the width commits to the next one, a longer drag skips further. */
            var s = track.firstElementChild
              ? track.firstElementChild.getBoundingClientRect().width : 0;
            var slides = s ? (startX - lastX) / s : 0;
            var jump = 0;
            if (Math.abs(slides) > 0.1) {
              jump = slides > 0 ? Math.max(1, Math.round(slides)) : Math.min(-1, Math.round(slides));
            }
            goTo(startIdx + jump);
          });
        });

        /* a drag that ends over a link or the badge shouldn't count as a click */
        track.addEventListener('click', function (e) {
          if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
        }, true);

        /* the grab cursor is the only hint that the track can be dragged, so it
           is worth showing wherever a real cursor exists */
        if (window.matchMedia('(pointer:fine)').matches) {
          track.classList.add('draggable');
        }
      }
    }
  })();

  /* ---------- PDP: quantity ---------- */
  document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById('PdpQty');
      if (!input) return;
      input.value = Math.max(1, parseInt(input.value || '1', 10) + parseInt(btn.dataset.qtyChange, 10));
    });
  });

  /* ---------- PDP: purchase plan + auto-refill consent gating ---------- */
  var planRadios = document.querySelectorAll('[name="selling_plan_choice"]');
  var sellingPlanInput = document.getElementById('SellingPlanInput');
  var disclosure = document.getElementById('SubDisclosure');
  var consent = document.getElementById('SubConsent');
  var priceEl = document.getElementById('PdpPrice');
  var addBtn = document.getElementById('PdpAddBtn');

  /* plan state, price display and the disclosure are all handled by the
     bundle block further down — this only keeps the consent gate wired. */

  var pdpForm = document.getElementById('PdpForm');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      /* No pack chosen — only reachable when preselection is switched off. Adding
         would silently send quantity 1 at whatever the form still held, so stop and
         point at the rows instead. */
      var packs = document.querySelectorAll('[name="pack_choice"]');
      if (packs.length && !document.querySelector('[name="pack_choice"]:checked')) {
        e.preventDefault();
        e.stopPropagation();
        showToast('Please choose a pack size');
        var tiersEl = document.querySelector('.tiers');
        if (tiersEl) {
          tiersEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          tiersEl.classList.add('needs-pick');
          setTimeout(function () { tiersEl.classList.remove('needs-pick'); }, 1600);
        }
        return;
      }

      var chosen = document.querySelector('[name="selling_plan_choice"]:checked');

      /* Subscribe is selected on a pack whose plan is misconfigured (see the
         data-sub-off safeguard): stop and say so rather than sell it one-time
         to someone who asked to subscribe, or on a plan priced for one filter. */
      var pick = document.querySelector('[name="pack_choice"]:checked');
      if (chosen && chosen.id === 'ModeSub' && pick && pick.dataset.subOff) {
        e.preventDefault();
        e.stopPropagation();
        showToast('Subscription isn\'t available for this pack yet — choose One-time purchase');
        return;
      }

      /* Subscribe is selected but Shopify gave us no plan id for this variant —
         the plan exists on the shop but is not applied to the product. Adding
         anyway would quietly sell a one-time filter to someone who asked to
         subscribe, so stop and say what is wrong. */
      if (chosen && chosen.id === 'ModeSub' && !chosen.value) {
        e.preventDefault();
        e.stopPropagation();
        if (window.console) {
          console.error('[cart] no selling plan allocated to this variant — ' +
            'check the subscription plan is applied to this product in Shopify');
        }
        showToast('Subscription is not available for this item yet');
        return;
      }

      /* consent box is optional in the layout; when present it must be ticked */
      if (chosen && chosen.value !== '' && consent && !consent.checked) {
        e.preventDefault();
        e.stopPropagation();
        consent.focus();
        showToast('Please check the Auto-Refill consent box to enrol');
      }
    });
  }

  /* ---------- PDP: variant select ---------- */
  /* initial cart count */
  refreshCart();
})();

/* ---------- mobile navigation ---------- */
(function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var panel  = document.querySelector('[data-mobile-nav]');
  if (!toggle || !panel) return;

  function setOpen(open) {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { panel.removeAttribute('hidden'); }
    else { panel.setAttribute('hidden', ''); }
    document.body.style.overflow = open ? 'hidden' : '';
  }

  toggle.addEventListener('click', function () {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });

  /* close on link tap, on Escape, and if the window grows to desktop */
  panel.addEventListener('click', function (e) {
    if (e.target.closest('a')) setOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') { setOpen(false); toggle.focus(); }
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth > 900 && toggle.getAttribute('aria-expanded') === 'true') setOpen(false);
  });
})();

/* ---------- sticky buy bar on phones ---------- */
(function () {
  var bar    = document.querySelector('[data-buybar]');
  var anchor = document.getElementById('PdpAddBtn');
  if (!bar || !anchor) return;

  var barPrice = bar.querySelector('[data-buybar-price]');
  var barLabel = bar.querySelector('[data-buybar-label]');
  var bundle   = document.querySelector('[data-bundle]');
  var baseSku  = barLabel ? barLabel.textContent.trim() : '';

  /* mirror whatever the shopper has actually chosen */
  function sync() {
    if (!bundle) return;
    var row = bundle.querySelector('[name="pack_choice"]:checked');
    if (!row) return;
    var tile = row.closest('.tier');

    /* the rows show a per-filter price, so the bar mirrors the button: the pack
       total on its own, which is what the shopper is about to be charged */
    var total = document.querySelector('[data-btn-total]');
    if (barPrice && total) barPrice.textContent = total.textContent;

    if (barLabel) {
      var name = tile && tile.querySelector('.tier-name');
      var mode = bundle.querySelector('[name="selling_plan_choice"]:checked');
      var sub  = !!(mode && mode.value);
      barLabel.textContent = (name ? name.textContent.trim() : baseSku) +
                             (sub ? ' · every 6 months' : '');
    }
  }

  if (bundle) {
    bundle.addEventListener('change', function () { setTimeout(sync, 0); });
    bundle.addEventListener('click',  function () { setTimeout(sync, 0); });
  }
  /* the bundle block paints its prices on load; run after it, not with it */
  sync();
  setTimeout(sync, 0);
  window.addEventListener('load', sync);

  /* show it only once the real button has scrolled out of view */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('show', !entries[0].isIntersecting);
    }, { rootMargin: '-70px 0px 0px 0px' }).observe(anchor);
  }
})();


/* ---------- bundle & subscribe ---------- */
(function () {
  var root = document.querySelector('[data-bundle]');
  var qtyInput = document.getElementById('PdpQty');
  if (!root) return;

  var unit    = parseInt(root.dataset.unit, 10) || 0;
  var subUnit = parseInt(root.dataset.subUnit, 10) || unit;
  /* true only when Shopify published a real selling-plan allocation for this variant */
  var hasSubUnit = parseInt(root.dataset.subUnit, 10) > 0;
  /* 'pack'    — the pack deal applies on top of the subscriber rate
     'per_unit' — subscriber rate x quantity, which is Shopify's own default */
  var subPackPricing = root.dataset.subPackPricing || 'pack';
  var fmt     = root.dataset.money || window.RWF_MONEY_FORMAT || '${{amount}}';
  var subPct  = parseFloat(root.dataset.subPct) || 0;

  /* ---------- pack size -> gallery photo ----------
     "3:4, 5:4" means the 3-pack and the 5-pack both show the 4th photo. Written
     1-based in the theme editor because that is how the photos are numbered in
     Shopify admin; stored 0-based because that is how the track is indexed.
     Left empty the gallery never moves, so products without a pack shot behave
     exactly as before. */
  var packImages = (function () {
    var map = {};
    var raw = (root.dataset.packImages || '').trim();
    if (!raw) return map;
    raw.split(/[\n,;]+/).forEach(function (pair) {
      var bits = pair.split(':');
      if (bits.length < 2) return;
      var q = parseInt(bits[0], 10);
      var n = parseInt(bits[1], 10);
      if (q > 0 && n > 0) map[q] = n - 1;
    });
    return map;
  })();

  /* Which pack size the gallery is currently showing. Starts null so the first
     draw can tell "page just loaded" from "shopper changed the pack". */
  var shownQty = null;

  /* what a row says when there is nothing to save — editable in Customize so the
     wording does not need a code change */
  var fullPriceLabel = root.dataset.fullPriceLabel || '';

  var planInput  = document.getElementById('SellingPlanInput');
  var disclosure = document.getElementById('SubDisclosure');
  var bigPrice   = document.getElementById('PdpPrice');

  function cash(c) { return fmt.replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2)); }

  /* Charm-price the subscription total so it never lands on $22.22.
     .50 and above rounds up to X.97; below .50 drops a dollar and uses X.97. */
  var ending = parseInt(root.dataset.priceEnding, 10);
  if (isNaN(ending)) ending = 97;
  function tidy(cents) {
    if (!root.dataset.roundPrices) return cents;
    var d = Math.floor(cents / 100), c = cents % 100;
    if (c >= 50) return d * 100 + ending;
    return Math.max(ending, (d - 1) * 100 + ending);
  }
  function isSub() {
    var m = root.querySelector('[name="selling_plan_choice"]:checked');
    return !!(m && m.value);
  }
  function tier() { return root.querySelector('[name="pack_choice"]:checked'); }

  /* Three ways to price a pack:
       "payN"  -> charge for N filters however many are in the pack. This is the
                  buy-one-get-one form: "3:pay2" is three filters at the price of
                  two. Exact by construction and independent of the product's
                  price, so one tier string works across the whole catalogue.
       "12%"   -> that percent off the list price.
       "44.97" -> the exact bundle price. */
  function packPrice(raw, list, base) {
    base = base || unit;
    var bogo = /^pay\s*(\d+(?:\.\d+)?)$/i.exec(raw);
    if (bogo) return Math.round(base * parseFloat(bogo[1]));
    if (raw.slice(-1) === '%') {
      return Math.round(list * (100 - (parseFloat(raw) || 0)) / 100);
    }
    return Math.round(parseFloat(raw) * 100) || list;
  }

  /* ---------- per-pack selling plans ----------
     Shopify prices a subscription from the selling plan, so the only way the
     recurring charge can equal the first charge is for each pack size to have its
     own plan. We read the plans from Shopify's own product JSON rather than from
     Liquid, so what the page shows is what Shopify will bill on every renewal.

     planByUnitPrice maps a plan's per-filter price to its id:
       2099 -> 690661065039   (1 filter,  $4.00 off)
       1899 -> 690673582415   (2 filters, $6.00 off)
       1699 -> 690673615183   (3 filters, $8.00 off)

     A tier's 4th field is its subscription total; divide by the quantity to get
     the per-filter price and look it up. No match means no plan for that pack,
     and subscribing to it is blocked rather than quoting a price we cannot bill. */
  var planByUnitPrice = null;

  /* The plans are printed into data-plans by Liquid, for the variant actually being
     sold. This used to be fetched from /products/<handle>.js at runtime, which was
     fragile: the fetch could fail, resolve after the first paint, or pick the wrong
     variant. When it did, planFor() returned null and checkout silently fell back to
     the toggle's default plan — the page said $50.97 and Shopify billed $62.97. */
  function loadPlans() {
    var raw = (root.dataset.plans || '').trim();
    if (!raw) return null;
    var map = null;
    raw.split(',').forEach(function (pair) {
      var bits = pair.split(':');
      var price = parseInt(bits[0], 10);
      var id = (bits[1] || '').trim();
      if (price > 0 && id) { map = map || {}; map[price] = id; }
    });
    return map;
  }

  /* the plan whose per-filter price times this quantity equals the tier's total */
  function planFor(input) {
    if (!planByUnitPrice) return null;
    var qty = parseInt(input.dataset.qty, 10) || 1;
    var fixed = input.dataset.subPrice;
    if (!fixed) return null;
    var want = Math.round(parseFloat(fixed) * 100);
    if (!(want > 0) || want % qty !== 0) return null;      /* must divide exactly */
    var perUnit = want / qty;
    var id = planByUnitPrice[perUnit];
    return id ? { id: id, total: want } : null;
  }

  /* A tier may carry its own exact subscription price (the 4th field in the tier
     string). When a matching plan exists that price is what Shopify bills; when it
     does not, it is still the price to show, and the fallback below covers tiers
     with no 4th field at all. */
  function subPrice(input, raw, qty, oneTimeNet) {
    /* 1. a selling plan built for this exact pack size — Shopify bills its price,
       so when one exists it always wins */
    var plan = planFor(input);
    if (plan) return plan.total;

    /* 2. an exact price written into the tier's 4th field */
    var fixed = input.dataset.subPrice;
    if (fixed) {
      var cents = Math.round(parseFloat(fixed) * 100);
      if (cents > 0) return cents;
    }

    if (hasSubUnit) {
      /* Shopify's own default: the subscriber rate on every unit in the pack. */
      if (subPackPricing === 'per_unit') return subUnit * qty;
      /* Pack deal on top of the subscriber rate — "3:pay2" charges for two
         filters at the subscriber price and ships three. Needs a selling plan
         per pack size to bill correctly; see the theme setting's note. */
      return packPrice(raw, subUnit * qty, subUnit);
    }

    /* 3. no allocation published at all */
    return tidy(Math.round(oneTimeNet * (100 - subPct) / 100));
  }


  /* ---------- packs as variants ----------
     When a row carries data-variant, the pack is a real Shopify variant: its
     price is the variant's price, its subscription price is what Shopify
     allocated to that variant, and adding it to the cart means sending that
     variant at quantity 1. Nothing about how the row looks changes. */
  var variantInput = document.getElementById('PdpVariantId');
  var baseVariant  = variantInput ? variantInput.value : '';

  function rowNet(input, raw, qty, list, sub) {
    if (input.dataset.variant) {
      var net = parseInt(input.dataset.net, 10);
      if (!(net > 0)) net = list;
      if (sub && !input.dataset.subOff) {
        var subNet = parseInt(input.dataset.subNet, 10);
        /* Shopify's own allocation is exact; fall back to the store rule only
           when the plan has not been applied to this variant yet */
        net = subNet > 0 ? subNet : tidy(Math.round(net * (100 - subPct) / 100));
      }
      /* data-sub-off: Shopify's subscription price for this pack is no higher
         than the single's (a fixed-price plan). The pack stays at its one-time
         price and is never sent with a plan — see the Liquid safeguard. */
      return net;
    }
    var n = packPrice(raw, list);
    if (sub) n = subPrice(input, raw, qty, n);
    return n;
  }

  /* keep the address bar honest: ?variant= names the pack, like any Shopify
     variant page, and ?selling_plan= names the subscription when one is chosen,
     so a link can be shared or landed on with both the pack and the purchase
     mode already selected. Shopify reads both parameters on load. */
  function reflectVariant(id, planId) {
    if (!id || !window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      var samePlan = (url.searchParams.get('selling_plan') || '') === (planId || '');
      if (url.searchParams.get('variant') === id && samePlan) return;
      url.searchParams.set('variant', id);
      if (planId) url.searchParams.set('selling_plan', planId);
      else url.searchParams.delete('selling_plan');
      window.history.replaceState(null, '', url.toString());
    } catch (e) { /* older browsers without URL(): leave the address alone */ }
  }

  function draw() {
    var sub = isSub();
    root.classList.toggle('is-sub', sub);

    /* toggle state */
    root.querySelectorAll('.mode').forEach(function (m) {
      m.classList.toggle('on', m.querySelector('input').checked);
    });

    /* every row reprices for the chosen mode */
    root.querySelectorAll('.tier').forEach(function (row) {
      var input = row.querySelector('input');
      var qty   = parseInt(input.dataset.qty, 10) || 1;
      var raw   = (input.dataset.price || '0').trim();

      var list = unit * qty;                       /* qty x single price, no discount */
      var net = rowNet(input, raw, qty, list, sub);

      var saved = list - net;
      var per   = Math.round(net / qty);

      row.classList.toggle('on', input.checked);

      /* the row leads with what one filter costs; the pack total is on the button */
      row.querySelector('[data-tier-now]').textContent = cash(per);
      row.querySelector('[data-tier-was]').textContent = saved > 0 ? cash(unit) : '';

      /* the saving is stated as an amount, not a percentage — cash is the figure
         people act on, and it needs no badge to be read. A row with no saving says
         so in words rather than leaving a blank line the eye has to interpret. */
      var amount = saved > 0 ? 'Save ' + cash(saved) : fullPriceLabel;

      var deskBits = [];
      if (qty > 1) deskBits.push(cash(net) + ' total');
      if (amount)  deskBits.push(amount);
      row.querySelector('[data-tier-sub]').textContent = deskBits.join(' · ');

      /* narrow screens drop the total — it is on the button and in the sticky bar */
      var mob = row.querySelector('[data-tier-sub-mob]');
      if (mob) mob.textContent = amount;
    });

    /* the chosen row drives quantity, plan and headline price */
    var chosen = tier();
    if (chosen) {
      var qty  = parseInt(chosen.dataset.qty, 10) || 1;
      var raw2 = (chosen.dataset.price || '0').trim();
      var list2 = unit * qty;
      var net = rowNet(chosen, raw2, qty, list2, sub);

      var isVariant = !!chosen.dataset.variant;
      if (variantInput) variantInput.value = isVariant ? chosen.dataset.variant : baseVariant;
      /* a pack variant is one item that happens to hold several filters */
      if (qtyInput) qtyInput.value = isVariant ? 1 : qty;

      /* Bring the pack photo forward, but only when the pack size is what
         actually changed — draw() also runs for the Subscribe / One-time toggle,
         and the gallery sliding sideways on that would be baffling. The first
         draw jumps with no animation so the page doesn't visibly scroll itself
         on load, since the largest pack is pre-selected. The pack-image map wins;
         a variant's own photo is the fallback. */
      var imgIdx = packImages[qty];
      if (imgIdx === undefined && chosen.dataset.img) imgIdx = parseInt(chosen.dataset.img, 10);
      if (qty !== shownQty && window.rwfGallery && imgIdx !== undefined && !isNaN(imgIdx)) {
        window.rwfGallery.show(imgIdx, shownQty !== null);
      }
      shownQty = qty;

      /* the button carries the total, with the undiscounted figure struck through */
      var btnTotal = document.querySelector('[data-btn-total]');
      var btnWas   = document.querySelector('[data-btn-was]');
      if (btnTotal) btnTotal.textContent = cash(net);
      if (btnWas)   btnWas.textContent   = (list2 - net) > 0 ? cash(list2) : '';
      var btnDot = document.querySelector('.pdp-add .btn-dot');
      if (btnDot) btnDot.style.display = '';

      var mode = root.querySelector('[name="selling_plan_choice"]:checked');
      if (planInput) {
        /* Prefer the plan that belongs to this pack size — that is the one whose
           price Shopify will bill on every renewal. Fall back to the toggle's plan
           only when no per-pack plan exists, so behaviour is unchanged on products
           that still have a single plan. */
        var planId = '';
        if (sub && chosen && chosen.dataset.subOff) {
          planId = '';   /* misconfigured plan for this pack: one-time only */
        } else if (sub) {
          if (isVariant) {
            /* one plan group covers every pack variant; Shopify prices it per
               variant, so the allocated plan is the one to bill */
            planId = chosen.dataset.plan || (mode ? mode.value : '');
          } else {
            var packPlan = chosen ? planFor(chosen) : null;
            planId = packPlan ? String(packPlan.id) : (mode ? mode.value : '');
          }
        }
        planInput.value = planId;
        planInput.disabled = !planId;
        if (isVariant) reflectVariant(chosen.dataset.variant, planId);
      }
      if (bigPrice) {
        bigPrice.innerHTML = sub
          ? cash(net) + '<small>every 6 months · cancel anytime</small>'
          : cash(net);
      }
      var amt = root.querySelector('[data-disc-amount]');
      var dq  = root.querySelector('[data-disc-qty]');
      if (amt) amt.textContent = cash(net);
      if (dq)  dq.textContent  = qty > 1 ? ' (' + qty + ' filters per delivery)' : '';
      /* terms line and headline price are optional in the layout */
    } else {
      /* Preselection is switched off and nothing is chosen yet. There is no pack,
         so there is no price to quote — the button shows its label alone rather
         than a figure the shopper has not asked for, and the form carries no plan.
         The submit guard below stops an add until a row is picked. */
      var btnTotal0 = document.querySelector('[data-btn-total]');
      var btnWas0   = document.querySelector('[data-btn-was]');
      if (btnTotal0) btnTotal0.textContent = '';
      if (btnWas0)   btnWas0.textContent   = '';
      var btnDot0 = document.querySelector('.pdp-add .btn-dot');
      if (btnDot0) btnDot0.style.display = 'none';
      if (qtyInput)  qtyInput.value = 1;
      if (variantInput) variantInput.value = baseVariant;
      if (planInput) { planInput.value = ''; planInput.disabled = true; }
      if (bigPrice)  bigPrice.textContent = '';
    }

    if (disclosure) disclosure.classList.toggle('show', sub);
  }

  root.addEventListener('change', draw);

  /* Plans are read synchronously, before the first draw, so the price shown and the
     plan submitted are decided together — never a window where the row shows a
     bundle price while the form still holds the default plan. */
  planByUnitPrice = loadPlans();

  /* the +/- buttons write .value directly and fire nothing */
  draw();
})();

/* ---------- lazy video frames ----------
   Shared by the video row and the customer-video cards on product pages. A frame
   shows only its poster until someone taps play; then the real <video> is built
   from the <template> beside it and dropped in. Starting one clip pauses any other
   inside the same root, so two never talk over each other. */
function bindLazyVideos(root) {
  function stopOthers(except) {
    root.querySelectorAll('video').forEach(function (v) {
      if (v !== except && !v.paused) v.pause();
    });
    root.querySelectorAll('[data-vslide-frame]').forEach(function (f) {
      if (!f.contains(except)) f.classList.remove('playing');
    });
  }

  root.querySelectorAll('[data-vslide-play]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var frame = btn.closest('[data-vslide-frame]');
      if (!frame) return;

      var video = frame.querySelector('video');
      if (!video) {
        /* first tap: build the player from the template and drop it in */
        var tpl = frame.querySelector('[data-vslide-video]');
        if (!tpl) return;
        var node = tpl.content ? tpl.content.cloneNode(true) : null;
        if (!node) return;
        frame.appendChild(node);
        video = frame.querySelector('video');
        if (!video) return;
        video.classList.add('vslide-video');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.addEventListener('pause', function () { frame.classList.remove('playing'); });
        video.addEventListener('ended', function () { frame.classList.remove('playing'); });
        /* iOS Safari may never pick a <source> for a player that was created inside
           a <template>; an explicit load() makes it choose one. Must stay inside
           the tap handler so the play() that follows still counts as user-initiated. */
        video.load();
      }

      stopOthers(video);
      frame.classList.add('playing');
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          /* This clip could not start — a codec the browser lacks, or a blocked
             gesture. Only reset this frame; a clip already playing elsewhere was
             paused by stopOthers and should not also lose its overlay state. */
          frame.classList.remove('playing');
        });
      }
    });
  });
}

/* ---------- customer videos (product page) ----------
   Same lazy frames as the video row. */
(function () {
  var box = document.querySelector('[data-ugc]');
  if (box) bindLazyVideos(box);
})();

/* ---------- video slider ----------
   Swipe/drag the row; the play-on-tap behaviour is bindLazyVideos above. */
(function () {
  var slider = document.querySelector('[data-vslider]');
  if (!slider) return;

  var track = slider.querySelector('[data-vslider-track]');
  if (!track) return;

  function step() {
    var first = track.firstElementChild;
    if (!first) return 0;
    var gap = parseFloat(getComputedStyle(track).columnGap);
    return first.getBoundingClientRect().width + (isNaN(gap) ? 16 : gap);
  }

  function goTo(i) {
    var s = step();
    if (!s) return;
    var max = track.children.length - 1;
    i = Math.max(0, Math.min(max, i));
    track.scrollTo({ left: i * s, behavior: 'smooth' });
  }

  function index() {
    var s = step();
    return s ? Math.round(track.scrollLeft / s) : 0;
  }

  bindLazyVideos(slider);

  if (track.children.length > 1) {
    /* Dots: reflect the position on scroll, and jump to a clip when tapped. Kept
       out of the tab order — the row itself is focusable and takes arrow keys, so
       the dots would only add a dozen redundant stops. */
    var dots = slider.querySelectorAll('[data-vslider-dot]');

    function markDot() {
      if (!dots.length) return;
      var i = index();
      dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.dataset.vsliderDot, 10) || 0);
      });
    });

    var dotTick = false;
    track.addEventListener('scroll', function () {
      if (dotTick) return;
      dotTick = true;
      requestAnimationFrame(function () { markDot(); dotTick = false; });
    });

    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      goTo(index() + (e.key === 'ArrowRight' ? 1 : -1));
    });

    /* drag for mice; touch keeps the browser's own momentum */
    var dragging = false, startX = 0, startLeft = 0, startIdx = 0, moved = 0, lastX = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      if (e.target.closest('[data-vslide-play]') || e.target.tagName === 'VIDEO') return;
      dragging = true; moved = 0;
      startX = lastX = e.clientX;
      startLeft = track.scrollLeft;
      startIdx = index();
      track.classList.add('dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      lastX = e.clientX;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      track.scrollLeft = startLeft - dx;
    });

    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      track.addEventListener(evt, function (e) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('dragging');
        try { track.releasePointerCapture(e.pointerId); } catch (err) {}
        var s = track.firstElementChild
          ? track.firstElementChild.getBoundingClientRect().width : 0;
        var slides = s ? (startX - lastX) / s : 0;
        var jump = 0;
        if (Math.abs(slides) > 0.1) {
          jump = slides > 0 ? Math.max(1, Math.round(slides)) : Math.min(-1, Math.round(slides));
        }
        goTo(startIdx + jump);
      });
    });

    /* a drag that ends on the play button should not count as a tap */
    track.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    if (window.matchMedia('(pointer:fine)').matches) track.classList.add('draggable');
  }
})();

/* ---------- fit checker ----------
   Answers "does this fit my fridge" from the product's compatible_models list.

   The list is always partial — one filter fits well over a hundred fridge models
   and no catalogue keeps up. So a model we cannot find is never reported as "does
   not fit". It falls back to the test that is actually authoritative and that the
   shopper is holding: the part number on the cartridge being replaced. The only
   firm no is a wrong brand, which genuinely cannot fit.

   Before either of those, though, the model is looked up across every other
   product in the store (fit-index.liquid). If a different filter lists it, that
   filter is offered right here with an add-to-cart button — the shopper landed on
   the wrong page, and the fix is one tap, not a search. */
(function () {
  var box = document.querySelector('[data-fitcheck]');
  if (!box) return;

  var modelIn = box.querySelector('[data-fit-model]');
  var brandIn = box.querySelector('[data-fit-brand]');
  var out     = box.querySelector('[data-fit-out]');
  if (!modelIn || !out) return;

  var OEM    = (box.dataset.oem || '').trim();
  var HELP   = box.dataset.help || '/#faq';
  var MODELS = (box.dataset.models || '').split('|')
                 .map(function (m) { return m.trim(); })
                 .filter(Boolean);

  /* Every part number this filter is sold under. People often read the number off
     the cartridge they are replacing rather than hunting for the fridge's model
     sticker, so treat a part-number entry as a confident yes too. */
  var OEMS = (box.dataset.oemlist || '').split(/[,|]/)
                 .map(function (m) { return m.trim(); })
                 .filter(Boolean);

  /* people type spaces, dashes and lower case; the sticker has none of that */
  function norm(s) { return (s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function key(s)  { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }

  /* ---- which brand(s) this filter is made for ----
     Read from every place the merchant may have said so: the fits metafield, tags
     ("fits:Samsung", "brand:Samsung" or plain "Samsung"), the brand collections
     the product belongs to, and the title ("Samsung DA97-17376B …"). The vendor
     counts only if it is itself a brand name — on most stores it is the shop's own
     name, which is how this box used to insist a Samsung filter "won't fit a
     Samsung". Matching is whole-word, so "GE" is not found inside "cartridge". */
  var VOCAB = [];
  if (brandIn) {
    Array.prototype.forEach.call(brandIn.options, function (o) {
      var v = (o.value || '').trim();
      if (v && v !== '__other') VOCAB.push(v);
    });
  }
  /* other ways the same brand gets written in titles and tags */
  var ALIAS = {
    'general electric': 'GE', 'kitchen aid': 'KitchenAid', 'jenn air': 'Jenn-Air',
    'jennair': 'Jenn-Air', 'everydrop': 'Whirlpool', 'sears': 'Kenmore'
  };

  function hasWord(hay, name) {
    var safe = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('(^|[^A-Za-z0-9])' + safe + '(?=$|[^A-Za-z0-9])', 'i').test(hay);
  }
  function brandsIn(text) {
    var found = [];
    if (!text) return found;
    VOCAB.forEach(function (b) {
      if (hasWord(text, b) && found.indexOf(b) === -1) found.push(b);
    });
    Object.keys(ALIAS).forEach(function (a) {
      var b = ALIAS[a];
      if (hasWord(text, a) && found.indexOf(b) === -1) found.push(b);
    });
    return found;
  }

  var ds = box.dataset;
  var BRANDS = [].concat(brandsIn(ds.fits), brandsIn(ds.tags),
                         brandsIn(ds.collections), brandsIn(ds.title));
  BRANDS = BRANDS.filter(function (b, i) { return BRANDS.indexOf(b) === i; });
  if (!BRANDS.length) BRANDS = brandsIn(ds.vendor);

  /* Brands that share a maker, so a filter made for one fits the other — a
     Whirlpool filter is the KitchenAid and Maytag filter too. Kenmore is a retailer
     label built by nearly every maker (Whirlpool, LG, Frigidaire, Samsung, GE), so
     it never earns a firm "no" in either direction; the model number decides. */
  var FAMILY = {
    whirlpool:  ['whirlpool', 'kitchenaid', 'maytag', 'amana', 'jenn-air'],
    electrolux: ['frigidaire', 'electrolux'],
    ge:         ['ge', 'general electric', 'hotpoint', 'cafe', 'café', 'monogram'],
    bosch:      ['bosch', 'thermador', 'gaggenau'],
    samsung:    ['samsung'],
    lg:         ['lg']
  };
  var CROSS = ['kenmore', 'sears'];

  function familyOf(b) {
    var k = key(b), f;
    for (f in FAMILY) {
      if (FAMILY[f].some(function (x) { return key(x) === k; })) return f;
    }
    return null;
  }
  function isCross(b) { return CROSS.indexOf(key(b)) !== -1; }

  /* true = no reason to say no. Only a brand we know, from a different maker,
     on a product whose brand we also know, is a firm no. */
  function brandOk(chosen) {
    var k = key(chosen);
    if (!k || chosen === '__other' || !BRANDS.length || isCross(chosen)) return true;
    var fam = familyOf(chosen);
    return BRANDS.some(function (b) {
      return key(b) === k || isCross(b) || (fam && familyOf(b) === fam);
    });
  }
  function listBrands(arr) {
    if (arr.length < 2) return arr.join('');
    return arr.slice(0, -1).join(', ') + ' and ' + arr[arr.length - 1];
  }
  /* "an LG", "an Electrolux", but "a GE", "a Samsung" */
  function article(name) {
    var first = String(name || '').charAt(0);
    var initialism = /^[A-Z]{2,}$/.test(String(name || '').trim());
    if (initialism ? 'AEFHILMNORSX'.indexOf(first) !== -1 : 'AEIOU'.indexOf(first.toUpperCase()) !== -1) return 'an';
    return 'a';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Exact, then either side being a prefix of the other — a model family shares a
     stem and differs only by a finish suffix (…SR, …SG, …AL), which shoppers drop
     or mistype constantly. Eight characters is long enough that two genuinely
     different families cannot collide. Part numbers are checked first: a typed
     part number is the surest signal there is. */
  function matchIn(q, oems, models) {
    var i, n;
    for (i = 0; i < oems.length; i++) {
      if (norm(oems[i]) === q) return { part: oems[i], exact: true };
    }
    for (i = 0; i < models.length; i++) {
      if (norm(models[i]) === q) return { model: models[i], exact: true };
    }
    for (i = 0; i < models.length; i++) {
      n = norm(models[i]);
      if (q.length >= 8 && (n.indexOf(q) === 0 || q.indexOf(n) === 0)) {
        return { model: models[i], exact: false };
      }
    }
    return null;
  }
  function findModel(entered) {
    var q = norm(entered);
    return q ? matchIn(q, OEMS, MODELS) : null;
  }

  /* ---- the rest of the catalogue ----
     fit-index.liquid renders every other product's model list and part numbers
     as JSON. A model that is not on this page is looked up there, so the shopper
     can be sent to (or sold) the right filter instead of being left guessing. */
  var INDEX = { products: [], collections: [] };
  var idxEl = box.querySelector('[data-fit-index]');
  if (idxEl) {
    try { INDEX = JSON.parse(idxEl.textContent) || INDEX; }
    catch (e) { if (window.console) console.warn('[fit] index unreadable', e); }
  }
  function splitList(s) {
    return String(s || '').split(/[,|]/).map(function (x) { return x.trim(); }).filter(Boolean);
  }
  var OTHERS = (INDEX.products || []).map(function (pr) {
    return {
      title: pr.t, url: pr.u, img: pr.img, price: pr.price, id: pr.id,
      avail: !!pr.avail, oem: pr.oem || '',
      oems: splitList(pr.oems), models: splitList(pr.models)
    };
  });

  function findElsewhere(entered) {
    var q = norm(entered), hits = [];
    if (!q) return hits;
    OTHERS.forEach(function (pr) {
      var r = matchIn(q, pr.oems, pr.models);
      if (r) hits.push({ product: pr, match: r });
    });
    /* exact matches before family-prefix ones, in-stock before sold out */
    hits.sort(function (a, b) {
      return (b.match.exact - a.match.exact) || (b.product.avail - a.product.avail);
    });
    return hits.slice(0, 3);
  }

  /* The brand's own collection, for the "find the right filter" link when no
     product matched. Shortest matching title wins ("Samsung" over "Samsung 3-packs"). */
  function collectionFor(brand) {
    var best = null;
    (INDEX.collections || []).forEach(function (c) {
      if (c.t && c.u && hasWord(c.t, brand) && (!best || c.t.length < best.t.length)) best = c;
    });
    return best ? best.u : null;
  }

  function altCards(hits) {
    return '<div class="fitcheck-alts">' + hits.map(function (h) {
      var pr = h.product;
      var action = pr.avail && pr.id
        ? '<button type="button" class="fitcheck-alt-add" data-quick-add="' + esc(pr.id) + '">Add to cart</button>'
        : '<a class="fitcheck-alt-add" href="' + esc(pr.url) + '">View</a>';
      return '<div class="fitcheck-alt">' +
        (pr.img ? '<img src="' + esc(pr.img) + '" alt="" width="56" height="56" loading="lazy">' : '') +
        '<div class="fitcheck-alt-body">' +
          '<a class="fitcheck-alt-title" href="' + esc(pr.url) + '">' + esc(pr.title) + '</a>' +
          '<span class="fitcheck-alt-meta">' +
            (pr.oem ? esc(pr.oem) + ' \u00b7 ' : '') + (pr.price || '') +
          '</span>' +
        '</div>' + action +
      '</div>';
    }).join('') + '</div>';
  }

  function say(kind, html) {
    out.className = 'fitcheck-out show ' + kind;
    out.innerHTML = html;
  }

  function check() {
    var entered = modelIn.value.trim();
    var shown   = entered.toUpperCase();   /* how it reads on the sticker */
    var brand   = brandIn ? brandIn.value : '';

    if (!entered) {
      say('warn', 'Enter your model number and we\'ll check it.');
      modelIn.focus();
      return;
    }

    /* 1. On this product's own list? That list is the merchant's own word, so it
          wins even when the brand dropdown disagrees — a mis-picked brand is far
          likelier than a model filed under the wrong product. */
    var hit = findModel(entered);
    if (hit && hit.part) {
      say('yes', '<b>Yes — this is the ' + esc(hit.part) + '.</b> ' +
                 'That\'s the part number this filter replaces.');
      return;
    }
    if (hit) {
      say('yes', '<b>Yes — this filter fits the ' + esc(hit.model) + '.</b>');
      return;
    }

    /* 2. Not here — is it anywhere else in the store? */
    var alts = findElsewhere(entered);

    /* 3. Wrong brand is the one honest "no". If the model they typed belongs to
          another filter we sell, hand them that filter instead of a search. */
    if (!brandOk(brand)) {
      var made = BRANDS.length === 1
        ? 'This is ' + article(BRANDS[0]) + ' <b>' + esc(BRANDS[0]) + '</b> filter'
        : 'This filter is made for <b>' + esc(listBrands(BRANDS)) + '</b> refrigerators';
      var noMsg = made + ', so it won\'t fit ' + article(brand) + ' <b>' + esc(brand) +
                  '</b> refrigerator.';
      if (alts.length) {
        noMsg += alts[0].match.part
          ? ' The <b>' + esc(alts[0].match.part) + '</b> is this one:'
          : ' The filter for your <b>' + esc(shown) + '</b> is this one:';
        say('no', noMsg + altCards(alts));
      } else {
        say('no', noMsg + ' <a href="' + esc(collectionFor(brand) || '/collections/all') +
                  '">Find the right filter →</a>');
      }
      return;
    }

    /* 4. Right brand, wrong page: another filter lists this model. */
    if (alts.length) {
      var lead = alts[0].match.part
        ? '<b>' + esc(alts[0].match.part) + ' is a different filter</b> — here it is:'
        : '<b>We don\'t list this filter for the ' + esc(shown) + '</b> — but we do list ' +
          (alts.length > 1 ? 'these:' : 'this one:');
      say('swap', lead + altCards(alts));
      return;
    }

    /* Not found. Say so honestly, then hand over the test that always works. */
    var msg = '<b>We can\'t confirm that model from our list</b> — our lists are ' +
              'partial, so it may still fit.';
    if (isCross(brand)) {
      msg += ' Kenmore fridges are built by several makers, so the filter you\'re ' +
             'replacing is the reliable test.';
    }
    if (OEM) {
      msg += ' Check the filter you\'re replacing: if it\'s marked <b>' + esc(OEM) +
             '</b>, this one fits.';
    }
    msg += ' <a href="' + esc(HELP) + '">Message us and we\'ll confirm →</a>';
    say('warn', msg);
  }

  box.querySelector('[data-fit-go]').addEventListener('click', check);
  modelIn.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); check(); }
  });

  var more = box.querySelector('[data-fit-more]');
  var list = box.querySelector('[data-fit-list]');
  if (more && list) {
    more.addEventListener('click', function () {
      var open = list.hasAttribute('hidden');
      if (open) { list.removeAttribute('hidden'); } else { list.setAttribute('hidden', ''); }
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = (open ? 'Hide the ' : 'See all ') + MODELS.length +
                         (open ? ' models' : ' models this filter fits');
    });
  }
})();
